// Types
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";

import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export interface IPayPlansByPositions {
	_id: string;
	name: string;
	position: string;
	available: boolean;
	pdfAvailability: boolean;
}

export async function getPayPlansByPositions(locationId: string, positions: string[]): Promise<IPayPlansByPositions[] | null> {
	const query = gql`
		query getPayPlansByPositions($locationId: String!, $positions: [String]) {
			getPayPlansByPositions(locationId: $locationId, positions: $positions) {
				_id
				name
				position
				available
				pdfAvailability
			}
		}
	`;

	const variables = {
		locationId,
		positions,
	};

	try {
		const response: GraphqlQueryResponse<"getPayPlansByPositions", IPayPlansByPositions[]> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getPayPlansByPositions || [];
	} catch (err) {
		errorLogger(err as Error);
		return null;
	}
}

export async function getPositionDraw(locationId: string, position: string) {
	const query = gql`
		query getPositionDraw($locationId: String!, $position: String!) {
			getPositionDraw(locationId: $locationId, position: $position)
		}
	`;

	const variables = {
		locationId,
		position,
	};

	try {
		const response: GraphqlQueryResponse<"getPositionDraw", string> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getPositionDraw ?? "";
	} catch (err) {
		errorLogger(err as Error);
	}

	return "";
}

export async function getPayPlansAssigmentTree(locationId: string, positions: string[]): Promise<IPayPlansByPositions[]> {
	const available = true;
	const query = gql`
		  query getPayPlansAssigmentTree($locationId: String!, $positions: [PositionInput], $available: Boolean!) {
			getPayPlansAssigmentTree(locationId: $locationId, positions: $positions, available: $available) {
                    _id
                    name
                    position
                    available
                    createdAt
                    createdBy {
                      _id
                      fullName
                    }
                    updatedAt
                    updatedBy {
                      _id
                      fullName
                    } 
                  }
                }
	`;

	const variables = {
		locationId,
		positions,
		available
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getPayPlansAssigmentTree || [];
	} catch (err) {
		errorLogger(err as Error);
		return [];
	}
}
